var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_core.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_core.js
// module chunks = 2